export default theme => ({
  keywordContainer: {
    marginBottom: theme.sizes[3],
    textAlign: "center",
  },
  keyword: {
    marginTop: theme.sizes[1],
    marginRight: theme.sizes[3],
  },
});
